import React from 'react';

import './Spinner.css';

export function Spinner() {
    return <div className="spinner-container">
        <div className="spinner" />
    </div>
}
